interface AuthHeaderProps {
  view?: 'sign_in' | 'sign_up' | 'update_password';
}

export const AuthHeader = ({ view = 'sign_in' }: AuthHeaderProps) => {
  const getHeaderText = () => {
    switch (view) {
      case 'sign_up':
        return 'Create an account';
      case 'sign_in':
        return 'Welcome back';
      case 'update_password':
        return 'Reset your password';
      default:
        return 'Welcome';
    }
  };

  const getSubHeaderText = () => {
    switch (view) {
      case 'sign_up':
        return 'Enter your details to get started';
      case 'sign_in':
        return 'Enter your credentials to access your account';
      case 'update_password':
        return 'Enter your new password below';
      default:
        return '';
    }
  };

  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
        {getHeaderText()}
      </h2>
      <p className="mt-2 text-center text-sm text-gray-600">
        {getSubHeaderText()}
      </p>
    </div>
  );
};